import React from "react";
import Modal from "react-modal";

const ModalCard = ({ children, isOpen }: any) => {
  return <Modal isOpen={isOpen} className="rounded-md">{children}</Modal>;
};

export default ModalCard;
